/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PolygonGeometry
 */
export interface PolygonGeometry {
    /**
     * 
     * @type {string}
     * @memberof PolygonGeometry
     */
    type: PolygonGeometryTypeEnum;
    /**
     * 
     * @type {Array<Array<Array<number>>>}
     * @memberof PolygonGeometry
     */
    coordinates: Array<Array<Array<number>>>;
}


/**
 * @export
 */
export const PolygonGeometryTypeEnum = {
    Polygon: 'Polygon'
} as const;
export type PolygonGeometryTypeEnum = typeof PolygonGeometryTypeEnum[keyof typeof PolygonGeometryTypeEnum];


/**
 * Check if a given object implements the PolygonGeometry interface.
 */
export function instanceOfPolygonGeometry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "coordinates" in value;

    return isInstance;
}

export function PolygonGeometryFromJSON(json: any): PolygonGeometry {
    return PolygonGeometryFromJSONTyped(json, false);
}

export function PolygonGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PolygonGeometry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function PolygonGeometryToJSON(value?: PolygonGeometry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'coordinates': value.coordinates,
    };
}

